export default __webpack_public_path__ + "static/media/microsoft-icon.22fe9cdc.png";